import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select"; // ✅ react-select
import { getZones } from "store/actions"; // To fetch zone list

const CreateArea = ({ visible, handleClose, initialData = "", onSubmit }) => {
  const dispatch = useDispatch();

  // Get zones from Redux
  const zones = useSelector((state) => state.Zone.zones);

  useEffect(() => {
    dispatch(getZones());
  }, [dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      areaName: initialData?.areaName || "",
      zoneId: initialData?.zoneId || "",
    },
    validationSchema: Yup.object({
      areaName: Yup.string().required("Area Name is required"),
      zoneId: Yup.string().required("Zone is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (initialData?.areaId) {
        onSubmit({
          sp: "usp_UpdateArea",
          ...values,
          areaId: initialData?.areaId,
        });
        onClose();
      } else {
        onSubmit({
          sp: "usp_InsertArea",
          ...values,
        });
        onClose();
      }
    },
  });

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  // ✅ Format zones for react-select
  const zoneOptions = zones?.Data?.map((zone) => ({
    value: zone.zoneId,
    label: zone.zoneName,
  })) || [];

  return (
    <Modal
      title={initialData ? "Edit Area" : "Create New Area"}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      centered
      width={600}
      className="custom-modal-header p-0"
      maskClosable={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div role="document">
          <div className="row g-3">
            {/* Area Name */}
            <div className="col-md-12">
              <label className="form-label fs-7">
                Area Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                placeholder="Enter area name"
                name="areaName"
                value={formik.values.areaName}
                onChange={formik.handleChange}
              />
              {formik.touched.areaName && formik.errors.areaName && (
                <span style={{ color: "red" }} role="alert">
                  {formik.errors.areaName}
                </span>
              )}
            </div>

            {/* Zone Dropdown (React-Select) */}
            <div className="col-md-12">
              <label className="form-label fs-7">
                Zone <span className="text-danger">*</span>
              </label>
              <Select
                name="zoneId"
                options={zoneOptions}
                value={zoneOptions.find(
                  (option) => option.value === formik.values.zoneId
                )}
                onChange={(selected) =>
                  formik.setFieldValue("zoneId", selected?.value || "")
                }
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable={true}
                placeholder="Select Zone"
              />
              {formik.touched.zoneId && formik.errors.zoneId && (
                <span style={{ color: "red" }} role="alert">
                  {formik.errors.zoneId}
                </span>
              )}
            </div>
          </div>

          {/* Footer buttons */}
          <div className="modal-footer mt-3">
            <button type="button" className="btn btn-light" onClick={onClose}>
              Close
            </button>
            <button type="submit" className="btn btn-primary ms-3">
              {initialData ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

CreateArea.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

export default CreateArea;
